<template>
    <b-card>
        <h2><strong>Penjualan Barang</strong></h2>
        <b-row class="justify-content-center">
            <b-col sm="12" md="8">
                <b-form-group label="Pilih Barang">
                    <v-select :options="barangOptions" v-model="filter.barang_id" label="text" :reduce="option => option.value" />
                </b-form-group>
            </b-col>
            <b-col cols="12" class="d-flex align-items-center justify-content-center">
                <b-form-group label="Dari" class="mr-1">
                <b-form-input v-model="filter.tgl_awal" type="date"></b-form-input>
                </b-form-group>
                <b-form-group label="Sampai" class="mr-1">
                <b-form-input v-model="filter.tgl_akhir" type="date"></b-form-input>
                </b-form-group>
                <b-form-group label="-">
                <b-button variant="primary" @click.prevent="getGraphicData" :disabled="!isValidForm"><feather-icon icon="FilterIcon" class="mr-1" />Filter</b-button>
                </b-form-group>
            </b-col>
        </b-row>
        <app-echart-bar :optionData="option" />
    </b-card>
</template>
<script>
import AppEchartBar from "@core/components/charts/echart/AppEchartBar.vue"
import {BCard, BRow, BCol, BFormGroup, BFormInput, BButton} from 'bootstrap-vue'
import vSelect from 'vue-select'
export default {
    components: {
        BCard, BRow, BCol, BFormGroup, BFormInput, BButton, AppEchartBar, vSelect
    },
    computed: {
        canView() {
            if(!this.isOwner || !this.isGM) {
                return false
            }

            return true
        },
        isValidForm() {
            if(!this.filter.barang_id || !this.filter.tgl_awal || !this.filter.tgl_akhir) {
                return false
            }

            return true
        }
    },
    data: () => ({
        barangOptions: [],
        option: {
            xAxis: [
                {
                    type: 'category',
                    data: [],
                },
            ],
            yAxis: [
                {
                    type: 'value',
                    splitLine: { show: true },
                    alignTicks: true
                },
            ],
            grid: {
                left: '40px',
                right: '30px',
                bottom: '30px',
            },
            series: [
                {
                    type: 'bar',
                    data: [],
                    barMaxWidth: '20%',
                    barMinWidth: '15px'
                }
            ],
        },
        filter: {
            barang_id: null,
            tgl_awal: '2022-11-01',
            tgl_akhir: '2022-11-20'
        }
    }),
    methods: {
        async getBarang() {
            const params = {
                order: 'desc'
            }
            if(this.isGM) params.jenis = 2

            const barangs = await this.$store.dispatch('barang/getData', params)
            this.barangOptions = barangs.map(barang => ({value: barang.id, text: barang.nama}))
        },
        getDateMonth(datestr) {
            const arr = datestr.split('/')
            return arr[0] + '/' + arr[1]
        },
        async getGraphicData() {
            const params = {}
            if(this.filter.tgl_awal) params.tgl_awal = this.filter.tgl_awal
            if(this.filter.tgl_akhir) params.tgl_akhir = this.filter.tgl_akhir

            if(this.filter.barang_id) params.barang_id = this.filter.barang_id

            try {
                const {labels, data} = await this.$store.dispatch('dashboard/getGrafikBarang', params)
                this.option.xAxis[0].data = labels
                const dataStok = {
                    value: data[0],
                    itemStyle: {
                        color: '#00cfe8'
                    }
                }
                const dataTerjual = {
                    value: data[1],
                    itemStyle: {
                        color: '#ff9f43'
                    }
                }
                const dataHilang = {
                    value: data[2],
                    itemStyle: {
                        color: '#4cef47'
                    }
                }
                const dataRusak = {
                    value: data[3],
                    itemStyle: {
                        color: '#ea5455'
                    }
                }
                this.option.series[0].data = [dataStok, dataTerjual, dataHilang, dataRusak]
                
            }
            catch(e) {
                this.displayError(e)
                return false
            }
        },
        getLast7Days() {
            let result = []
            const num = 7
            for(let i = 0; i <= num; i++) {
                const currentDate = new Date()
                const ii = i == 0 ? currentDate.getDate() : currentDate.getDate() - i
                currentDate.setDate( ii )
                result.push(currentDate)
            }
            result = result.reverse()
            const tgl_awal = result[0]
            const tgl_akhir = result[result.length - 1]
            const awalMonth = tgl_awal.getMonth() + 1 < 10 ? `0${tgl_awal.getMonth() + 1}` : tgl_awal.getMonth()
            const akhirMonth = tgl_akhir.getMonth() + 1 < 10 ? `0${tgl_akhir.getMonth() + 1}` : tgl_akhir.getMonth()
            const awalDate = tgl_awal.getDate() < 10 ? `0${tgl_awal.getDate()}` : tgl_awal.getDate()
            const akhirDate = tgl_akhir.getDate() < 10 ? `0${tgl_akhir.getDate()}` : tgl_akhir.getDate()
            this.filter.tgl_awal = `${tgl_awal.getFullYear()}-${awalMonth}-${awalDate}`
            this.filter.tgl_akhir = `${tgl_akhir.getFullYear()}-${akhirMonth}-${akhirDate}`
        }
    },
    created() {
        this.getLast7Days()
        this.getBarang()
    }
}
</script>